<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 100%;width: 100%;overflow-y: auto;padding-top: 20px;box-sizing: border-box" v-loading="loading" element-loading-text="加载中，请耐心等待。">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: 50px;">
              <el-button type="primary" plain icon="el-icon-plus" @click="addUser()">新建员工</el-button>&nbsp;&nbsp;
              <el-input prefix-icon="el-icon-search" placeholder="输入人员姓名搜索" v-model="searchKeyword" clearable style="width: 350px"></el-input>
            </div>
            <div style="max-height: calc(100% - 100px);overflow-y: auto">
              <el-table
                :data="tbdata"
                border
                style="width: 100%"
                highlight-current-row
                ref="singleTable">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70"
                align="center">
                </el-table-column>
                <el-table-column
                  prop="jobnum"
                  label="工号"
                  min-width="60"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="人员姓名"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="联系方式"
                  min-width="60"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="账号用户名"
                  min-width="60"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getUserName(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="所属组织"
                  min-width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getOnOrg(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="地址"
                  min-width="110"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="sip电话"
                  width="120"
                  align="center">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-phone-outline" @click="bindSip(scope.row)">绑定</el-button>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="80">
                  <template slot-scope="scope">
                    <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editUser(scope.row)"></i>
                    <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delUser(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCells">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--created-->
    <el-dialog
      :visible.sync="addShow"
      v-if="addShow"
      width="800px"
      :show-close="true"
      :close-on-click-modal="false"
      center
    class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>新建员工</span>
        </div>
        <div class="line-title"></div>
      </div>
      <user-add :userAddRow="addRow" v-model="addShow"></user-add>
    </el-dialog>
    <!--update-->
    <el-dialog
      :visible.sync="editShow"
      v-if="editShow"
      width="800px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>更新员工</span>
        </div>
        <div class="line-title"></div>
      </div>
      <user-edit :userEditRow="editRow" v-model="editShow"></user-edit>
    </el-dialog>
    <el-dialog
      :title="sipTitle"
      :visible.sync="sipShow"
      v-if="sipShow"
      width="600px"
      :show-close="true"
      :close-on-click-modal="false"
      center>
      <bind-sip :sips="rowSip" v-model="sipShow"></bind-sip>
    </el-dialog>
  </div>
</template>

<script>
import treeData from '../treeData/treeData.vue'
import userAdd from './childComponents/userAdd'
import userEdit from './childComponents/userEdit'
import {queryorgperson, deleteorgperson} from '../../api/orguser'
import {querysip} from '../../api/sipPhone'
import {queryuser} from '../../api/account'
import bindSip from './childComponents/bindSip'
export default {
  name: 'user',
  components: {treeData, userAdd, userEdit, bindSip},
  data () {
    return {
      sip: [],
      sipTitle: '',
      sipShow: false,
      rowSip: {
        sips: [],
        row: ''
      },
      filterText: '',
      orgData: [],
      // 左边
      searchKeyword: '',
      isFirst: [],
      // 右边
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addShow: false,
      addRow: {
        orgTree: []
      },
      editShow: false,
      editRow: {
        orgTree: [],
        row: {}
      },
      users: []
    }
  },
  created () {
    this.golobleObject.updateTableUser = this.newGetData
    this.getAccount()
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    getAccount () {
      queryuser().then(res => {
        this.users = res.data.users
        this.sipPhoneData()
      }).catch(() => {})
    },
    sipPhoneData () {
      querysip().then(res => {
        this.sip = res.data.orgsips
        this.rowSip.sips = this.sip
        this.getUserTable()
      }).catch(() => {})
    },
    checkChange (obj) {
      if (obj.type === 'check') {
        this.currentPage = 1
        this.isFirst = obj.orgids
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.addRow.orgTree = obj.treeData
        this.editRow.orgTree = obj.treeData
        this.getEndTable()
      }
    },
    newGetData (val) {
      if (val) {
        queryuser().then(res => {
          this.users = res.data.users
          this.getUserTable()
        }).catch(() => {})
      } else {
        this.getUserTable()
      }
    },
    // 表格
    getUserTable () {
      this.tableData = []
      queryorgperson().then(res => {
        let isTime = res.data.orgpersons.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.tableData = res.data.orgpersons
        this.getEndTable()
        this.loading = false
      }).catch(() => {})
    },
    getEndTable () {
      this.showTable = []
      if (this.isFirst.length === 0) {
        this.showTable = this.tableData
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.isFirst.indexOf(this.tableData[i].orgid) > -1) {
            this.showTable.push(this.tableData[i])
          }
        }
      }
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.showTable
      const vm = this
      const search = data.filter((val) => {
        if (val.name.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    // 表格
    getUserName (row) {
      for (let i = 0; i < this.users.length; i++) {
        if (parseInt(row.id) === parseInt(this.users[i].spid)) {
          return this.users[i].username
        }
      }
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    // 新建平台人员
    addUser () {
      this.addShow = true
    },
    // 编辑平台人员
    editUser (row) {
      this.editRow.row = row
      this.editShow = true
    },
    // 删除平台人员
    delUser (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该员工【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          opids: [row.id]
        }
        deleteorgperson(data).then(res => {
          this.getUserTable()
          this.$notify({
            title: '成功',
            message: '成功删除平台人员',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除平台人员失败'
          })
        })
      }).catch(() => {})
    },
    // 绑定sip电话
    bindSip (row) {
      this.sipTitle = '【' + row.name + '】绑定sip电话'
      this.rowSip.row = row
      this.sipShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/user.vue